var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "incentive-root" }, [
    _c(
      "div",
      {
        staticClass: "custom-nav-block",
        style: `padding-top:${_vm.barHeight}px`,
      },
      [
        _c("van-nav-bar", {
          staticClass: "van-bar",
          attrs: { title: "", "left-arrow": "" },
          on: { "click-left": _vm.closeWeb },
          scopedSlots: _vm._u([
            {
              key: "left",
              fn: function () {
                return [
                  _c("img", {
                    staticClass: "left-nav",
                    attrs: {
                      src: require("@/assets/packageAssets/common/arrow05.png"),
                      alt: "",
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
    _c("img", {
      staticClass: "content-img",
      staticStyle: { width: "100%" },
      style: { "margin-top": `-${_vm.barHeight * 1 + 46}px` },
      attrs: { src: require("./images/content-img.png") },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }